import { useState } from 'react';
import { singletonHook } from 'react-singleton-hook';

const useTabBackButtonStateImp = () => {
  const state = useState(null);

  return state;
};

const useTabBackButtonState = singletonHook([null, () => {}], useTabBackButtonStateImp);

export default useTabBackButtonState;
